import {MutationTree} from 'vuex';
import {AppState, AppStateField, getDefaultState} from '@/store/app-state';
import Vue from 'vue';
import {User} from '@/types/user';

export enum StoreMutation {
  SET_USER = 'setUser',
  SET_INITIATOR = 'setInitiator',
  SET_MESSAGE = 'setMessage',
  CLEAR_STATE = 'clearState',
}

export const mutations: MutationTree<AppState> = {
  /**
   * Обновление информации о текущем пользователе
   */
  setUser(state: AppState, user: User) {
    Vue.set(state, AppStateField.USER, user);
  },

  setMessage(state: AppState, data: any) {
    Vue.set(state, AppStateField.MESSAGE, data);
  },

  setInitiator(state: AppState, data: any) {
    Vue.set(state, AppStateField.INITIATOR, data);
  },

  /**
   * Очистка состояния
   */
  clearState(state: AppState) {
    Object.assign(state, getDefaultState());
  }
};
